import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import RouterCards from 'components/Motion_Detection/Router_as_a_FTP_Server/RouterCards';
import NavButtons from 'components/Motion_Detection/NavButtons';
import ForumBox from 'components/Motion_Detection/Router_as_a_FTP_Server/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  RouterCards,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};